import React from "react";
import { Container } from "react-bootstrap";
const Advertising = () => {
    return (
        <Container fluid>
            <h4 className="py-3"> Advertising </h4>
        </Container>
    );
}
export default Advertising;